const contactText = `If you are interested in hiring me or collaboration you can contact me directly through Email.`;

export default contactText;
